<!----
    Author: hjlee
    Description:
        다국어, 일반텍스트 전환하여 입력받을 수 있는 컨트롤
---->
<template>
  <input-control
    v-if="multilanguage"
    v-model="inputVal"
    type="i18n"
    :rules="rules"
    :title="title"
    :name="name"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
  />
  <input-control
    v-else
    v-model="inputVal"
    type="text"
    :rules="rules"
    :title="title"
    :required="required"
    :name="name"
    :readonly="readonly"
    :disabled="disabled"
  />
</template>

<script>
export default {
  props: {
    multilanguage: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: [Array, String],
      required: true
    },
    rules: {
      type: [Object, String],
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      inputVal: undefined
    }
  },
  computed: {
    hasError() {
      return this.errors.has(this.name)
    },
    computedRules: function() {
      return 'required'
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    },
    inputVal: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.$emit('input', newVal)
          this.$emit('change', newVal)
          this.$emit('forceUpdate')
        })
      },
      deep: true
    },
    multilanguage: function(newVal) {
      if (newVal) {
        this.inputVal = []
      } else {
        this.inputVal = ''
      }
    }
  },
  mounted() {
    if (!this.value && this.multilanguage) {
      this.inputVal = []
    } else {
      this.inputVal = this.value
    }
  }
}
</script>
